export const START_LOADING = "START_LOADING";
export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOG_DETAILS = "GET_BLOG_DETAILS";
export const ADD_TO_HISTORY = "ADD_TO_HISTORY";
export const ADD_NEW_BLOG = "ADD_NEW_BLOG";
export const SET_CURRENT_BLOG = "SET_CURRENT_BLOG";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const DELETE_BLOG = "DELETE_BLOG";

// Sorting
export const SET_SORT = "SET_SORT";
export const SORT_LAST_UPLOAD = "SORT_LAST_UPLOAD";
export const SORT_FIRST_UPLOAD = "SORT_FIRST_UPLOAD";
export const SORT_MOST_VIEWED = "SORT_MOST_VIEWED";

// Filtering
export const FILTER_BLOG = "FILTER_BLOG";
